import React, { SFC, useEffect, useState } from "react";
import moment from "moment";
import CompletedInterviewActions from "containers/interviews/completed-interview-actions";
import Tooltip from "components/controls/tooltip";
import { get } from "js-cookie";
import "less/interview-item.less";
import { parseTimeZone } from "assets/localization";
import { timezoneAbbreviationLabel } from "shared/helpers/user";
import { getCurrencySymbol } from "shared/helpers/enums/currency";
import { getPlatformSymbol } from "shared/helpers/enums/interview-payment-source";
import { getPaymentStatusLabel } from "shared/helpers/enums/interview-payment-status";
import InvalidateInterviewModal from "containers/interviews/invalidate-interview-modal";
import cancelIcon from 'assets/icons/cancel.png'
import arrowUpIcon from 'assets/icons/arrowUp.png'
import whiteIcon from '../../assets/icons/whiteIcon.png'

const formatTime = (start, end, formatDate, timeZone) => {
  return `${formatDate(start, "MMMM DD, YYYY")} from ${formatDate(
    start,
    "hh:mm A",
  )} - ${formatDate(end, "hh:mm A")} ${timezoneAbbreviationLabel(timeZone)}`;
};

const RescheduleButtonWithTooltip = ({ isEnabled, onClick }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="reschedule-btn-tooltip-wrapper"
      onMouseEnter={() => {
        if (!isEnabled) setShowTooltip(true);
      }}
      onMouseLeave={() => {
        if (!isEnabled) setShowTooltip(false);
      }}
      style={{ display: "inline-block", position: "relative" }}
    >
      <button
        className={`reschedule-interview-btn${
          isEnabled ? " enabled" : " disabled"
        }`}
        style={{
          fontSize: "13px",
          fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
        }}
        onClick={(e) => {
          if (!isEnabled) {
            e.preventDefault();
            return;
          }
          if (typeof onClick === "function") {
            onClick();
          }
        }}
        tabIndex={isEnabled ? 0 : -1}
        aria-disabled={!isEnabled}
      >
        <i className="im-ss-counterclockwise" style={{ fontSize: 18, marginRight: 7 }} />
        Reschedule Interview
      </button>
      {!isEnabled && showTooltip && (
        <div className="reschedule-disabled-tooltip">
          <div className="tooltip-inner-text">
            Interview Already Rescheduled
          </div>
          <div className="tooltip-arrow" />
        </div>
      )}
    </div>
  );
};

const InterviewItem = ({
  projectName,
  startTime,
  endTime,
  firstName,
  lastName,
  //requiresStimulus,
  isCompleted,
  timeSlotId,
  hostModeratorId,
  //conferenceHash,
  //hostModeratorHash,
  manageInterview,
  invalidateInterview,
  rescheduleInterview,
  openRescheduleDirect,
  //cancelInterview,
  history,
  projectId,
  moderatorId,
  salesforceJobNumber,
  clientName,
  conferenceLink,
  formatDate,
  externalSurveyId,
  timeZone,
  topicName,
  defaultHonorariumAmount,
  defaultHonorariumCurrency,
  customHonorariumAmount,
  totalAmount,
  paymentDate,
  source,
  currency,
  participantFirstName,
  participantLastName,
  participantId,
  paymentStatus,
  openEditIncentiveModal,
  openCreditIncentiveModal,
  showCheckbox,
  isInvalidateEmailSent,
  isSelected,
  onSelect,
  isPmOrAdmin,
  t,
  showInvalidatedPill,
  showPreviousNoShow,
  activeTab,
  invalidationReasonCode,
  invalidationReasonText,
  isRescheduled,
  isPreviousNoShow,
  Ineligible,
  openChangeModerator,
  isGlobal,
  isProjectModerator
}) => {
  const start = moment(startTime).locale("en");
  const end = moment(endTime).locale("en");
  const [showInvalidateModal, setShowInvalidateModal] = useState(false);
  const [isInvalidateHovered, setIsInvalidateHovered] = useState(false);
  const isIneligible = Number(Ineligible) === 1;


  const statusLabel = showInvalidatedPill
    ? "Invalidated"
    : paymentStatus
      ? getPaymentStatusLabel(paymentStatus)
      : isCompleted
        ? "Past Due"
        : "";

  const statusClass = showInvalidatedPill
    ? "invalidated"
    : paymentStatus
      ? paymentStatus.replace(/_/g, "-").toLowerCase()
      : isCompleted
        ? "past-due"
        : "";

  const getInvalidationReasonLabel = (code) => {
    switch (code) {
      case "PARTICIPANT_NO_SHOW":
        return "Participant No Show";
      case "MODERATOR_NO_SHOW":
        return "Moderator No Show";
      case "OTHER":
      case "OTHERS":
        return "Other";
      default:
        return code ? code.replace(/_/g, " ") : "Unknown";
    }
  };

  return (
    <div className="interview-item-container">
      {showCheckbox && (
        <div className="interview-checkbox">
          <input type="checkbox" checked={isSelected} onChange={onSelect} />
        </div>
      )}
      <div className={`interview-payment-status ${statusClass}`}>
        {statusLabel}
      </div>
      {(activeTab === "upcoming" || activeTab === "completed") && isIneligible && (
        <div className="interview-eligibility-status">
          Qual Ineligible
        </div>
      )}
      <div className="left-info">
        <div className="interview-type">
          <i
            className={`${
              isCompleted ? "im-ic-interview" : "im-ic-interview upcoming"
            }`}
          />
        </div>
        <div className="interview-content">
          <div className="interview-name">
            {projectName} #{externalSurveyId}
          </div>
          <div className="interview-topic-name">
            {`Topic Name: ${topicName}`}
          </div>
          <div className="interview-info-wrapper">
            <div className="interview-info">
              <div className="interview-info-left">
                <div className="interview-time">
                  <i className="im-ss-clock icon" />
                  <div className="date-time-duration detail-text">
                    <div>
                      {formatTime(startTime, endTime, formatDate, timeZone)}
                    </div>
                    <div>{end.diff(start, "minutes")} Minute Interview</div>
                  </div>
                </div>
                <div className="conference-link" style={activeTab === "upcoming" ? { marginTop: '8px' } : { marginTop: '12px' }}>
                  <i className="im-link2" />
                  <div className="conference-link-text detail-text">
                    <div>Conferencing Link</div>
                    <a
                      className="conference-link-2"
                      href={conferenceLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {conferenceLink}
                    </a>
                  </div>
                </div>
                <div className="salesforce-job-number">
                  <img
                    className="clients-interview-icon"
                    src="/images/briefcaseGrey.svg"
                    role="presentation"
                  />
                  <div className="salesforce-job-number-text detail-text">
                    {clientName && <div>{`Client: ${clientName}`}</div>}
                    <div>{`Salesforce Job Number: ${salesforceJobNumber}`}</div>
                  </div>
                </div>
              </div>
              <div className="interview-info-right">
                <div className="moderator-info">
                  <i className="im-scheduler-moderator-icon" />
                  <div className="moderator-info-text detail-text">
                    <div>
                      Moderator (HOST): {firstName} {lastName}
                    </div>
                    <div className="participant-line">
                      <span>
                        Participant: #{participantId} {participantFirstName}{" "}
                        {participantLastName}
                      </span>
                      {showPreviousNoShow && isPreviousNoShow && (
                          <span className="previous-no-show-pill">
                            PREVIOUS NO SHOW
                          </span>
                        )}
                    </div>
                  </div>
                </div>
                {showInvalidatedPill ? (
                  <div className="moderator-info invalidation-info">
                    <i className="im-blocked" />
                    <div className="moderator-info-text detail-text">
                      <div>
                        Invalidation Reason:{" "}
                        {getInvalidationReasonLabel(invalidationReasonCode)}
                      </div>
                      {(invalidationReasonCode === "OTHERS" ||
                        invalidationReasonCode === "OTHER") &&
                        Boolean(invalidationReasonText) && (
                          <div className="invalidation-reason-text">
                            {invalidationReasonText}
                          </div>
                        )}
                    </div>
                  </div>
                ) : (
                  <div className="moderator-info">
                    <i className="im-money" />
                    <div className="moderator-info-text detail-text">
                      {paymentStatus === "CREDITED" ? (
                        <>
                          <div className="value-edit-wrapper">
                            <div>
                              Reward Points: {parseInt(totalAmount) || "N/A"}
                            </div>
                          </div>
                          <div>
                            Incentive Paid Date:{" "}
                            {formatDate(paymentDate, "MMMM DD, YYYY HH:mm z") ||
                              "N/A"}
                          </div>
                          <div>Platform: {getPlatformSymbol(source)}</div>
                        </>
                      ) : (
                        <div className="value-edit-wrapper">
                          <div>
                            Reward Points:{" "}
                            {parseInt(
                              customHonorariumAmount || defaultHonorariumAmount,
                            ) || "N/A"}
                          </div>
                          {Boolean(
                            parseInt(
                              customHonorariumAmount || defaultHonorariumAmount,
                            ),
                          ) ? (
                            activeTab === "upcoming" ? (
                              <></>
                            ) : (
                              <div className="edit-incentive-button">
                                <button
                                  className="edit-link-btn"
                                  onClick={() =>
                                    openEditIncentiveModal({
                                      timeSlotId,
                                      initialIncentive: parseInt(
                                        customHonorariumAmount ||
                                          defaultHonorariumAmount,
                                      ),
                                      currency: getCurrencySymbol(
                                        defaultHonorariumCurrency,
                                      ),
                                    })
                                  }
                                >
                                  <i className="im-edit" />
                                  <span>EDIT</span>
                                </button>
                              </div>
                            )
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="interview-info-action">
              {activeTab === "upcoming" ? (
                <div className="interview-item-upcoming-actions interview-upcoming-actions im-edit-upcoming">
                  {isPmOrAdmin && (isGlobal || isProjectModerator) ? (
                    <button
                      className="change-moderator-btn"
                      onClick={() => {
                        if (typeof openChangeModerator === "function")
                          openChangeModerator();
                      }}
                    >
                      Change Moderator
                    </button>
                  ) : null}
                  <div onClick={manageInterview}>
                    <i title="Manage Interview" className="im-edit" />
                  </div>
                </div>
              ) : (
                isCompleted &&
                isPmOrAdmin &&
                paymentStatus !== "CREDITED" && (
                  <div className="interview-item-completed-actions interview-completed-actions">
                    {Boolean(
                      parseInt(
                        customHonorariumAmount || defaultHonorariumAmount,
                      ),
                    ) && (
                      <div className="incentive-button">
                        <button
                          className="credit-reward-btn"
                          onClick={() =>
                            openCreditIncentiveModal({
                              timeSlotId,
                              incentive: parseInt(
                                customHonorariumAmount ||
                                  defaultHonorariumAmount,
                              ),
                              currency: getCurrencySymbol(
                                defaultHonorariumCurrency,
                              ),
                            })
                          }
                        >
                          <img src={arrowUpIcon} alt="Home" />
                          <span style={{ marginLeft: "5px" }}>
                            {t("incentive.credit.btn.text")}
                          </span>
                        </button>
                      </div>
                    )}
                    <div className="invalidate-button">
                      <button
                        className="invalidate-btn"
                        onMouseEnter={() => setIsInvalidateHovered(true)}
                        onMouseLeave={() => setIsInvalidateHovered(false)}
                        onClick={() => setShowInvalidateModal(true)}
                      >
                        <img
                          src={isInvalidateHovered ? whiteIcon : cancelIcon}
                          alt="Home"
                        />
                        <span style={{ marginTop: "-4px", marginLeft: "5px" }}>
                          {t("interview.invalidate.btn.text")}
                        </span>
                      </button>
                    </div>
                  </div>
                )
              )}
              {showInvalidatedPill && (
                <div className="interview-item-completed-actions interview-completed-actions">
                  <RescheduleButtonWithTooltip
                    isEnabled={!isInvalidateEmailSent && !isRescheduled}
                    onClick={() => {
                      if (typeof rescheduleInterview === "function") {
                        rescheduleInterview();
                      }
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showInvalidateModal && (
        <InvalidateInterviewModal
          isOpen={showInvalidateModal}
          origin={"interviews"}
          onClose={() => setShowInvalidateModal(false)}
          onConfirm={({ action, reason, otherReason }) => {
            if (action === "invalidate_and_reschedule") {
              // Always open Reschedule modal; do NOT call invalidate API here
              if (showInvalidatedPill) {
                if (typeof rescheduleInterview === "function") {
                  rescheduleInterview({ action, reason, otherReason });
                } else if (typeof manageInterview === "function") {
                  manageInterview();
                }
              } else {
                if (typeof openRescheduleDirect === "function") {
                  openRescheduleDirect({ action, reason, otherReason });
                } else if (typeof manageInterview === "function") {
                  manageInterview();
                }
              }
            } else if (typeof invalidateInterview === "function") {
              invalidateInterview({
                timeSlotId,
                participantId,
                projectId,
                origin: "interviews",
                action,
                reason,
                otherReason,
              });
            } else if (typeof manageInterview === "function") {
              manageInterview();
            }
          }}
          projectName={`${projectName} #${externalSurveyId}`}
          participantId={participantId}
          startTime={startTime}
          endTime={endTime}
          timeZone={timeZone}
          formatDate={formatDate}
          moderatorName={`${firstName} ${lastName}`}
          t={t}
        />
      )}
    </div>
  );
};

export default InterviewItem;
